export const home = {
  methods: {

    //获取APP版本最后一条信息
    async getAppVersion() {
      let res = await this.$http.get("/tenant/version/getNew");
      return res.data;
    }
   
  
  },
};
